module.exports = __webpack_public_path__ + "img/procrastination.2338df7c.jpg";